import { NgModule } from '@angular/core';
import { MaterialModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from 'app/shared/shared.module';
import { ImportClientComponent } from 'app/admin/importclient/import-client.component';
import { MappingInstructionsComponent } from 'app/admin/importclient/mappinginstructions/mapping-instructions.component';
import { MappingFiltersComponent } from 'app/admin/importclient/mappingfilters/mapping-filters.component';
import { AddMappingComponent } from 'app/admin/importclient/mappingfilters/addmapping/add-mapping.component';
import { EditMappingComponent } from 'app/admin/importclient/mappingfilters/editmapping/edit-mapping.component';
import { SaveInstructionComponent } from 'app/admin/importclient/mappinginstructions/saveinstruction/save-instruction.component';
import { ImportClientService } from 'app/admin/importclient/import-client.service';

@NgModule({
    declarations: [
        ImportClientComponent,
        MappingFiltersComponent,
        MappingInstructionsComponent,
        EditMappingComponent,
        AddMappingComponent,
        SaveInstructionComponent
    ],
    imports: [
        MaterialModule.forRoot(),
        BrowserModule,
        FormsModule,
        FlexLayoutModule,
        SharedModule,
        ReactiveFormsModule
    ],
    entryComponents: [
        EditMappingComponent,
        AddMappingComponent,
        SaveInstructionComponent
    ],
    providers: [
        ImportClientService
    ]
})

export class ImportClientModule { }



// WEBPACK FOOTER //
// ./src/app/admin/importclient/import-client.module.ts